import React, { useState, useMemo, useEffect } from 'react';
import { IconButton, Tooltip, Dialog, DialogTitle, TextField, DialogContent, Button, DialogActions, MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import { faPlus, faRefresh, faPrint, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DynamicForm from '../DynamicForm';
import CentralCalls from '../../centralCalls';
import JSONTableEditor from '../JSONTableEditor';
import Autocomplete from '@mui/material/Autocomplete';
import WipPhaseFilesDialog from './WipPhaseFilesDialog';
// Define the component and destructure the prop from the component's props
const WipInspectionSection = ({ selectedLotOid }) => {
    const [addPhaseDialogOpen, setAddPhaseDialogOpen] = useState(false);
    const [refreshPhaseKey, setRefreshPhaseKey] = useState(4000);
    const [statusDialogOpen, setStatusDialogOpen] = useState(false);
    const [PunchDialogOpen, setPunchDialogOpen] = useState(false);
    const [punchPhaseType, setPunchPhaseType] = useState('Select');
    const [plumberList, setPlumberList] = useState([]);
    const [selectedPlumbers, setSelectedPlumbers] = useState([]);
    const [phaseFilesDialogOpen, setPhaseFilesDialogOpen] = useState(false);
    const [selectedPhaseFileOid, setSelectedPhaseFileOid] = useState(null);
    const [selectedPhaseFileLotOid, setSelectedPhaseFileLotOid] = useState(null);
    const phaseTypes = [
        { id: 9, name: 'Select', name_id: 'Select' },
        { id: 9, name: 'Slab', name_id: 'slab' },
        { id: 10, name: 'Rough', name_id: 'rough' },
        { id: 11, name: 'Drain Tubs', name_id: 'draintubs' },
        { id: 12, name: 'Set Out', name_id: 'setout' },
        { id: 13, name: 'Underground', name_id: 'underground' },
        { id: 14, name: 'Warranty', name_id: 'warranty' },
        { id: 15, name: 'Slab Quality Check', name_id: 'slab_qc' },
        { id: 16, name: 'Rough Quality Check', name_id: 'rough_qc' },
        { id: 17, name: 'Setout Quality Check', name_id: 'setout_qc' },
        { id: 18, name: 'Slab Inspection', name_id: 'slab_inspection' },
        { id: 19, name: 'Underground Inspection', name_id: 'underground_inspection' },
        { id: 20, name: 'Rough Inspection', name_id: 'rough_inspection' },
        { id: 21, name: 'Setout Inspection', name_id: 'setout_inspection' },
    ];
    useEffect(() => {
        CentralCalls.fetchTableDataNoWhere('employee').then(response => {
            const sortedResponse = response.slice().sort((a, b) => a.name.localeCompare(b.name));
            setPlumberList(sortedResponse);
        });
    }, []);
    //const [selectedPhaseRow, setSelectedPhaseRow] = useState(null);
    const [selectedPhase, setSelectedPhase] = useState(null);
    const addNewPoToPhase = async () => {
        //await CentralCalls.upsertData({ 'phase_oid': selectedPhase}, 'po', 'insert');
        //setRefreshIconKey(prevKey => prevKey + 1);
        setStatusDialogOpen(false);
        //setAddPODialogOpen(false);
    }
    const addPoClick = async (phaseRow) => {
        setSelectedPhase(phaseRow.phase_oid);
        setStatusDialogOpen(true);
        //setSelectedPhaseRow(phaseRow);
    }
    const handleSavePhaseDetails = async (slabRow) => {
        //console.log('Employee team..updating', slabRow);
        // console.log('Saving phase details', slabRow);
        // console.log(slabRow);
        if (Array.isArray(slabRow.employee_oids) && slabRow.employee_oids.length > 0) {
            var employee_team = await CentralCalls.callStoredProcedureWithParams('sp_getOrCreateCrew', {'employeeOids': slabRow.employee_oids});
            //console.log('employee_team',employee_team)
            CentralCalls.upsertData({'oid': slabRow.oid, employee_team_oid: employee_team[0].employee_team_oid}, 'phase_status', 'update');
        }
        CentralCalls.upsertData({ 'oid': slabRow.phase_oid, 'date_scheduled': slabRow.date_scheduled, 'builder_date': slabRow.builder_date, 'is_punch': slabRow.is_punch ? 1 : 0 }, 'phase', 'update');
    };
    const handlePhaseTypeSelected = async (phase_type) => {
        setPunchPhaseType(phase_type);
    }
    const closePunchDialog = async () => {
        setPunchDialogOpen(false);
        setPunchPhaseType('Select');
    }
    const handleAddPunchPostSave = async (phaseStat) => {
        //const newPhase = await CentralCalls.upsertData({ 'lot_oid': selectedLotOid, 'phase_type': punchPhaseType, 'is_punch': 1 }, 'phase', 'insert');
        if (Array.isArray(phaseStat.employee_oids) && phaseStat.employee_oids.length > 0) {
            
            //console.log('employee_team',employee_team)
            //await CentralCalls.upsertData({'oid': phaseStat.oid, employee_team_oid: employee_team[0].employee_team_oid}, 'phase_status', 'update');
        }
        var employee_team = await CentralCalls.callStoredProcedureWithParams('sp_getOrCreateCrew', {'employeeOids': phaseStat.employee_oids});
        await CentralCalls.upsertData({ 'phase_oid': phaseStat.oid, 'status': 'complete', status_date: CentralCalls.sqlFormatdate(phaseStat.status_date), employee_oids: JSON.stringify(phaseStat.employee_oids), employee_team_oid: employee_team[0].employee_team_oid, 'comments' : phaseStat.comments, 'hours' : phaseStat.hours, 'finished' :1 }, 'phase_status', 'insert');
        closePunchDialog();
    }
    const handleSelectedPlumberChange = (newValue) => {
        setSelectedPlumbers(newValue);
    }
    const addNewPhasePostSave = async (phaseRow) => {
        setAddPhaseDialogOpen(false);
        setRefreshPhaseKey(refreshPhaseKey + 1);
    }
    const procedureAddPOByPhaseDetailsInsert = useMemo(() => ({
        procedureName: 'ui_sp_wipAddPoByPhase',
        parameters: { 'phase_oid': selectedPhase, 'page_type': 'insert' },  // If there are any parameters, define them here as an object
    }), [selectedPhase]);
    const procedureAddPhaseDetails = useMemo(() => ({
        procedureName: 'ui_sp_wipInsertPunchPhase',
        parameters: { lot_oid: selectedLotOid },  // If there are any parameters, define them here as an object
    }), [selectedLotOid]);
    const procedureAddPunchDetails = useMemo(() => ({
        procedureName:'ui_sp_wipAddPunch',
        parameters: { lot_oid: selectedLotOid },
    }), [selectedLotOid])
    const slabProcedureDetails = useMemo(() => ({
        procedureName: 'ui_sp_getLotOverview',
        parameters: { 'lot_oid': selectedLotOid },  // If there are any parameters, define them here as an object
    }), [selectedLotOid]);
    const handleOpenPhaseFilesClick = async (phaseRow) => {
        setSelectedPhaseFileOid(phaseRow.phase_oid || null);
        setSelectedPhaseFileLotOid(phaseRow.lot_oid || selectedLotOid || null);
        setPhaseFilesDialogOpen(true);
    }

    const checkDisplayPhaseFiles = (phaseRow) => {
        const countField = phaseRow.file_count ?? phaseRow.files_count ?? phaseRow.phase_file_count ?? phaseRow.file_cnt;

        if (typeof countField === 'number') {
            return countField > 0;
        }

        if (typeof countField === 'string' && countField.trim() !== '') {
            const parsed = parseInt(countField, 10);
            return !Number.isNaN(parsed) && parsed > 0;
        }

        return false;
    }

    const customFunctionsWipPhases = [
        {
            display_name: 'Add PO',
            type: 'money', // type must correspond to a FontAwesome icon name
            func: addPoClick,
            alwaysEnable: true
        },
        {
            display_name: 'Files',
            type: 'phaseFiles',
            func: handleOpenPhaseFilesClick,
            alwaysEnable: true
        }
    ]
    return (
        <>
            <h2>Phases
                <Tooltip title="Add New Punch">
                    <IconButton color="primary" aria-label="save" onClick={() => setPunchDialogOpen(true)} size="medium">
                        <FontAwesomeIcon icon={faPlus} />
                    </IconButton>
                </Tooltip>
            </h2>
            <JSONTableEditor
                key={refreshPhaseKey}
                customFunctions={customFunctionsWipPhases}
                procedureDetails={slabProcedureDetails}
                onSave={handleSavePhaseDetails}
                sortOrder={{
                    'is_cancelled': 'asc',
                    'status_date': 'asc',
                    'phase_order': 'asc'
                }} />

            <Dialog fullWidth={true} maxWidth='lg' open={addPhaseDialogOpen} onClose={() => setAddPhaseDialogOpen(false)}>
                <DialogTitle></DialogTitle>
                <DialogContent >
                    <h2>New Phase</h2>
                    <DynamicForm procedureDetails={procedureAddPhaseDetails}
                        onSave={addNewPhasePostSave}
                        saveName='Add'
                        crudType='insert' ></DynamicForm>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAddPhaseDialogOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} maxWidth='lg' open={statusDialogOpen} onClose={() => setStatusDialogOpen(false)}>
                <DialogContent >
                    <>
                        <h2>New Po</h2>
                        <DynamicForm procedureDetails={procedureAddPOByPhaseDetailsInsert}
                            onSave={addNewPoToPhase}
                            saveName='Add'
                            crudType='insert' ></DynamicForm>
                    </>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setStatusDialogOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} maxWidth='lg' open={PunchDialogOpen} onClose={() => closePunchDialog()}>
                <DialogContent>
                    <>
                        <h2> New Job</h2>

                        <DynamicForm procedureDetails={procedureAddPunchDetails}
                        onSave={handleAddPunchPostSave}
                        saveName='Add'
                        crudType='insert' ></DynamicForm>

                        
                    </>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => closePunchDialog()} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <WipPhaseFilesDialog
                open={phaseFilesDialogOpen}
                onClose={() => setPhaseFilesDialogOpen(false)}
                phaseOid={selectedPhaseFileOid}
                selectedLotOid={selectedPhaseFileLotOid}
            />
        </>


    );

}

export default WipInspectionSection;